import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/v1/mission-claims', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getUnclaimedMissions = () => {
  return httpClient
    .get('/api/v1/mission-claims/unclaimed-missions')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getMissionDetail = missionId => {
  return httpClient
    .get(`/api/v1/mission-claims/mission-detail/${missionId}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const claim = (missionId, data) => {
  return httpClient
    .post(`/api/v1/mission-claims/claim/${missionId}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (missionId, data) => {
  const isFormData = data instanceof FormData
  return httpClient
    .post(`/api/v1/mission-claims/update/${missionId}`, data, {
      headers: isFormData
        ? { 'Content-Type': 'multipart/form-data' }
        : { 'Content-Type': 'application/json' }
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = missionId => {
  return httpClient
    .delete(`/api/v1/mission-claims/${missionId}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  getUnclaimedMissions,
  getMissionDetail,
  claim,
  update,
  destroy
}
